module.exports = __webpack_public_path__ + "img/ming_2.0b58e605.png";